import { PermissionType } from 'types/staff'
import { selectDefaultBreadTypes, selectTopTab } from 'reducks/auth/operations'

type BaseMenu = {
  label: string
  onClick?: () => void
  role: number
  url: string
}

type Menu = BaseMenu & {
  icon?: string
  childMenus?: BaseMenu[]
}

export const ownerMenus: Menu[] = [
  { label: '本日お渡しする注文', icon: 'schedule', role: 1, url: `/order/` },
  {
    icon: 'bread',
    label: 'sacriで出品する商品の管理',
    onClick: () => selectDefaultBreadTypes(['daily', 'preorder', 'delivery']),
    role: 9,
    url: '/product',
    childMenus: [
      { label: 'アプリの並び順を変更する', role: 9, url: '/product/order' },
      { label: '商品情報のテンプレート設定', role: 9, url: '/product/default' },
    ],
  },
  {
    label: 'お店でお渡し',
    icon: 'reservation',
    onClick: () => selectTopTab('hand_over'),
    role: 1,
    url: '/',
    childMenus: [
      { label: '商品の在庫増減と通知', role: 9, url: '/stock' },
      { label: '事前予約日一括設定', role: 9, url: '/schedule/collective_setting' },
      { label: 'タイムセール', role: 9, url: '/time_sale' },
    ],
  },
  {
    label: 'お取り寄せ',
    icon: 'delivery',
    onClick: () => selectTopTab('delivery'),
    role: 1,
    url: '/',
    childMenus: [
      { label: '未発送注文を確認', role: 9, url: '/order/delivery/preparing' },
      { label: 'お届け可能日設定', role: 9, url: '/schedule/delivery' },
      { label: '配送設定', role: 9, url: '/delivery/setting' },
    ],
  },
  {
    label: '売上確認',
    icon: 'revenue',
    role: 5,
    url: '/account/revenue',
    childMenus: [{ label: '月次レポート', role: 5, url: '/account/revenue/monthly_report' }],
  },
  {
    label: 'お客さまリスト',
    icon: 'customer',
    role: 9,
    url: '/customer',
    childMenus: [{ label: 'メッセージ配信', role: 9, url: '/customer/message' }],
  },
]

export const adminMenus: Menu[] = [
  {
    label: '店舗情報一覧',
    icon: 'home',
    role: 0,
    url: '/admin/shops',
    childMenus: [
      { label: '注文検索', role: 0, url: '/admin/orders/search' },
      { label: '新規店舗作成', role: 0, url: '/admin/shops/create/account' },
      { label: 'ブランド管理', role: 0, url: '/admin/brand' },
    ],
  },
  {
    label: '運営からのお知らせ',
    icon: 'coupon',
    role: 0,
    url: '/admin/push_notification',
    childMenus: [
      { label: 'クーポン', role: 0, url: '/admin/coupon' },
      { label: 'キャンペーン', role: 0, url: '/admin/campaign_cms' },
    ],
  },
  {
    label: '祝日の設定',
    icon: 'configuration',
    role: 0,
    url: '/admin/master/calendars',
    childMenus: [
      { label: '商品カテゴリー設定', role: 0, url: '/admin/master/categories' },
      { label: 'お店のオススメポイント', role: 0, url: '/admin/master/tags' },
    ],
  },
  { label: '店舗アカウント設定', icon: 'setting', role: 0, url: '/account' },
]

export const footerMenus: { label: string; target: '_blank' | '_self'; url: string }[] = [
  {
    label: 'アップデート情報',
    target: '_blank',
    url: 'https://www.notion.so/sacri/sacri-for-Owners-86886f669a9e4facb1876d964f8630e4',
  },
  {
    label: '利用規約',
    target: '_blank',
    url: 'https://sacri.jp/terms/',
  },
  {
    label: 'よくあるご質問',
    target: '_blank',
    url: 'https://sacrisupport.zendesk.com/hc/ja/categories/360003465253-出店者さま向けFAQ',
  },
  {
    label: 'プライバシーポリシー',
    target: '_blank',
    url: 'https://sacri.jp/privacy/',
  },
  {
    label: 'お問い合わせ',
    target: '_blank',
    url: 'https://sacrisupport.zendesk.com/hc/ja/requests/new',
  },
  {
    label: '運営会社',
    target: '_blank',
    url: 'https://sacri.jp/',
  },
]

export const mailMenus: { label: string; permission: PermissionType }[] = [
  { label: '当日取り置きの受注連絡', permission: 'order_daily' },
  { label: '事前予約注文の受注連絡', permission: 'order_preorder' },
  { label: '取り寄せの受注連絡', permission: 'order_delivery' },
  { label: '事前予約注文のリマインド', permission: 'remind_preorder' },
  { label: '取り寄せのリマインド', permission: 'remind_delivery' },
]

export const staffPushMenus: { label: string; permission: PermissionType }[] = [
  { label: '当日取り置きの受注連絡', permission: 'push_order_daily' },
  { label: '事前予約注文の受注連絡', permission: 'push_order_preorder' },
  { label: '取り寄せの受注連絡', permission: 'push_order_delivery' },
  { label: '事前予約注文のリマインド', permission: 'push_remind_preorder' },
  { label: '取り寄せのリマインド', permission: 'push_remind_delivery' },
]
